import { render } from "./Skills.vue?vue&type=template&id=3ec866e4&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=3ec866e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec866e4"]])

export default __exports__